import React, { Children } from 'react';
import { motion } from 'framer-motion';
const items = ['Wedding Vision Section', 'Budget Planner', 'Vendor Management Pages', 'Guest List Tracker', 'Seating Planning Layout', 'Timeline Builder', 'Checklist Pages', 'Mood Board Space', 'Notes Pages'];
export function IncludedSection() {
  return <section className="w-full bg-[#F9F5EF] py-24 px-6 md:py-32" data-id="element-148">
      <div className="max-w-6xl mx-auto" data-id="element-149">
        <div className="text-center mb-16" data-id="element-150">
          <span className="text-xs uppercase tracking-[0.2em] text-[#8FAF88] font-medium block mb-4" data-id="element-151">
            What's Included
          </span>
          <h2 className="text-4xl md:text-5xl font-light text-[#2C2C2C]" data-id="element-152">
            Inside the Planner
          </h2>
        </div>

        {/* Interior preview image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9
      }} className="flex justify-center mb-16" data-id="element-153">
          <img src="https://cdn.magicpatterns.com/uploads/wTfNy53HqAMzTB23nXim8Z/ChatGPT_Image_Feb_19,_2026,_08_06_49_PM.png" alt="Inside the Complete Wedding Planner — mood board and checklist pages" className="w-full max-w-2xl drop-shadow-xl rounded-sm" data-id="element-154" />
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.05
          }
        }
      }} data-id="element-155">
          {items.map((item, index) => <motion.div key={index} variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} className="bg-white p-8 border border-[#8FAF88]/20 hover:border-[#8FAF88]/50 transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-156">
              <span className="text-xs font-serif italic text-[#C4A882] mb-3 block opacity-60" data-id="element-157">
                0{index + 1}
              </span>
              <h3 className="text-xl font-serif text-[#2C2C2C] group-hover:text-[#6B8F64] transition-colors duration-300" data-id="element-158">
                {item}
              </h3>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="text-center mt-16 max-w-2xl mx-auto" data-id="element-159">
          <p className="text-lg text-[#2C2C2C] font-light leading-relaxed" data-id="element-160">
            Designed with structured layouts and generous spacing so you can
            think clearly and plan confidently.
          </p>
        </motion.div>
      </div>
    </section>;
}